module.exports = __webpack_public_path__ + "img/People Manager.92ba70c8.svg";